import React from "react";
import Slider1 from "../../assets/images/slider1.png";
import Slider2 from "../../assets/images/slider2.png";
import Slider3 from "../../assets/images/slider3.png";
import { home } from "../../data/home_data";
import { Carousel, Container, Row, Col, Card } from "react-bootstrap";
import "./home.css";

const Home = ({ history }) => {
  return (
    <>
      <Container style={{ marginTop: "20px" }} lg={4} md={12}>
        <Carousel>
          <Carousel.Item onClick={() => history.push("/products")}>
            <img className="d-block w-100" src={Slider1} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item onClick={() => history.push("/products")}>
            <img className="d-block w-100" src={Slider2} alt="Second slide" />
          </Carousel.Item>
          <Carousel.Item onClick={() => history.push("/products")}>
            <img className="d-block w-100" src={Slider3} alt="Third slide" />
          </Carousel.Item>
        </Carousel>
      </Container>
      <Container style={{ marginTop: "20px" }} lg={10}>
        <Row>
          <h1>Welcome to Sheik Halal Farms</h1>

          <div className="recorners">
            Sheik Halal Farms was established in 1996. From its very inception,
            SHF has had one singular focus-its functioning be devoted to Islamic
            law and dedicated to the following the guidelines of the Holy
            Qur'an. The company commenced as a specialty farming business
            involved in growing and producing Halal poultry products for
            Toronto, the Greater Toronto Area and Ottawa. SHF soon ventured into
            other meat products and flourished over the years as one of the
            leading halal slaughter houses in Canada.
          </div>
        </Row>
        <Row>
          {home.map((h) => {
            return (
              <Col key={h.id} xs={12} md={4}>
                <Card
                  style={{ width: "18rem", margin: "10px" }}
                  className="card_style"
                >
                  <Card.Img
                    variant="top"
                    src={h.img}
                    style={{ height: "200px" }}
                  />
                  <Card.Body>
                    <Card.Title>{h.title}</Card.Title>
                    <Card.Text>{h.text}</Card.Text>
                    <Card.Link href={h.link} style={{ color: "blue" }}>
                      more
                    </Card.Link>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

export default Home;
